import { jsx as h } from "react/jsx-runtime";
import { createContext as q, forwardRef as H, useContext as C, useState as F, useId as N, useRef as K, useEffect as $ } from "react";
import P from "../hooks/useOnClickOutside.js";
const g = q({
  /** @type {string} */
  comboboxInputId: null,
  /** @type {string} */
  comboboxListboxId: null,
  /** @type {boolean} */
  isListExpanded: !1,
  /** @type {React.Dispatch<React.SetStateAction<boolean>>} */
  setIsListExpanded() {
  },
  /** @type {(id: string) => void} */
  addOption() {
  },
  /** @type {(id: string) => void} */
  removeOption() {
  },
  /** @type {string?} */
  focusedOption: null,
  /** @type {(id: number|string?) => void} */
  focusOption() {
  },
  /** @type {(num: number) => void} */
  focusNextOption() {
  },
  focusFirstOption() {
  },
  focusLastOption() {
  },
  /** @type {(value: string) => string} */
  getOptionId() {
    return "";
  },
  /** @type {() => boolean} */
  getHasOptions() {
    return !1;
  },
  /** @type {(value: string) => void} */
  selectOption() {
  }
});
function E({ defaultSelectedOption: e = "", onSelectOption: c, ...l }) {
  const [i, f] = F(!1), u = N(), p = `${u}-input`, a = `${u}-listbox`, s = K(null);
  P(s, () => f(!1)), $(() => {
    i && document.querySelector(`[id="${p}"]`)?.focus();
  }, [i]);
  const t = K(
    /**@type {string[]}*/
    []
  );
  function x() {
    return t.current.length > 0;
  }
  function L(o) {
    t.current.push(o);
  }
  function m(o) {
    const w = t.current.findIndex((O) => O === o);
    w !== -1 && t.current.splice(w, 1);
  }
  function I(o) {
    return `${u}-option-${o?.toLowerCase().replace(/\s+/g, "-")}`;
  }
  const [d, r] = F(
    /**@type {string?}*/
    null
  );
  $(() => {
    if (i && (t.current.includes(d) || b(null), d != null)) {
      const o = document.querySelector(`[id="${I(d)}"]`);
      if (o == null) return;
      o.scrollIntoView({ block: "nearest" });
    }
  }, [d, i]);
  function b(o) {
    if (o == null || typeof o == "string") r(o);
    else if (typeof o == "number") r(t.current[o]);
    else throw new Error(`Invalid value type "${typeof o}", expected string or number`);
  }
  function y(o) {
    const w = t.current.findIndex((R) => R === d);
    let O = w === -1 ? Math.min(o, 0) : w + o;
    for (; O >= t.current.length; )
      O -= t.current.length;
    for (; O < 0; )
      O += t.current.length;
    b(O);
  }
  function k() {
    b(0);
  }
  function M() {
    b(t.current.length - 1);
  }
  const [A, n] = F(e);
  function D(o) {
    n(o), f(!1), r(null), c?.(o);
  }
  return $(() => () => {
    A !== e && c?.("");
  }, []), /* @__PURE__ */ h(
    g.Provider,
    {
      value: {
        comboboxInputId: p,
        comboboxListboxId: a,
        isListExpanded: i,
        setIsListExpanded: f,
        addOption: L,
        removeOption: m,
        focusedOption: d,
        focusOption: b,
        focusNextOption: y,
        focusFirstOption: k,
        focusLastOption: M,
        getOptionId: I,
        getHasOptions: x,
        selectOption: D
      },
      children: /* @__PURE__ */ h(
        "div",
        {
          id: u,
          ref: s,
          ...l
        }
      )
    }
  );
}
function S({ onClick: e, ...c }) {
  const {
    comboboxListboxId: l,
    isListExpanded: i,
    setIsListExpanded: f
  } = C(g);
  function u(p) {
    f((a) => !a), e?.(p);
  }
  return /* @__PURE__ */ h(
    "button",
    {
      type: "button",
      "aria-controls": l,
      "aria-expanded": i,
      onClick: u,
      ...c
    }
  );
}
const B = H(({
  as: e = "input",
  onKeyDown: c,
  onInput: l,
  onBlur: i,
  ...f
}, u) => {
  const {
    comboboxInputId: p,
    comboboxListboxId: a,
    isListExpanded: s,
    setIsListExpanded: t,
    focusedOption: x,
    focusOption: L,
    focusNextOption: m,
    focusFirstOption: I,
    focusLastOption: d,
    getOptionId: r,
    getHasOptions: b
  } = C(g), y = r(x);
  function k(n) {
    const D = b();
    if (D && ["Escape", "ArrowUp", "ArrowDown"].includes(n.code) || D && s && x != null && n.code === "Enter") {
      if (n.preventDefault(), n.stopPropagation(), n.code === "Enter") {
        if (t(!1), x == null) return;
        document.querySelector(`[id="${y}"]`)?.click?.();
      }
      n.code === "Escape" && (t(!1), L(null)), n.code === "ArrowUp" && (t(!0), !s && !n.altKey ? d() : s && m(-1)), n.code === "ArrowDown" && (t(!0), !s && !n.altKey ? I() : s && m(1));
    }
    n.defaultPrevented || c?.(n);
  }
  function M(n) {
    t(!0), l?.(n);
  }
  function A(n) {
    t(!1), i?.(n);
  }
  return /* @__PURE__ */ h(
    e,
    {
      id: p,
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-controls": a,
      "aria-expanded": s,
      "aria-activedescendant": y,
      onKeyDown: k,
      onInput: M,
      onBlur: A,
      ref: u,
      ...f
    }
  );
});
function T({ "aria-label": e, label: c = e, ...l }) {
  const { focusOption: i } = C(g);
  return /* @__PURE__ */ h(
    "ul",
    {
      id: null,
      role: "listbox",
      "aria-label": c,
      ...l
    }
  );
}
function U({ value: e, onMouseMove: c, onMouseDown: l, onClick: i, ...f }) {
  const { addOption: u, removeOption: p, focusedOption: a, getOptionId: s, focusOption: t, selectOption: x } = C(g), L = s(e);
  $(() => (u(e), () => p(e)), []);
  function m(r) {
    t(e), c?.(r);
  }
  function I(r) {
    r.preventDefault(), l?.(r);
  }
  function d(r) {
    x(e), i?.(r);
  }
  return /* @__PURE__ */ h(
    "li",
    {
      id: L,
      role: "option",
      "aria-selected": a === e,
      onMouseMove: m,
      onMouseDown: I,
      onClick: d,
      ...f
    }
  );
}
function W({ children: e }) {
  return e(C(g));
}
E.Trigger = S;
E.Input = B;
E.Listbox = T;
E.Option = U;
E.WithContext = W;
export {
  E as default
};
